import * as LDClient from 'launchdarkly-js-client-sdk';

import Helper from '../helpers/util';

const renderTestGroupBadge = () => {
	const testGroupName = window.launchDarklyClient.getUser()['custom']['TestGroup'];

	const mobileNavEl = document.querySelector('nav');
	const desktopNavEl = document.querySelector('.nav-sub-menu-container');

	const mobileTestGroupBadge = document.createElement('div');
	mobileTestGroupBadge.classList.add('mobile-nav__test-badge');
	mobileTestGroupBadge.innerText = `Beta ${
		testGroupName ? `(${testGroupName})` : ''
	}`;

	const desktopTestGroupBadge = document.createElement('div');
	desktopTestGroupBadge.classList.add('nav__test-badge');
	desktopTestGroupBadge.innerText = `Beta ${
		testGroupName ? `(${testGroupName})` : ''
	}`;

	desktopNavEl.prepend(desktopTestGroupBadge);
	mobileNavEl.prepend(mobileTestGroupBadge);
};

export const init = () => {
	return new Promise((resolve) => {
		if (!Helper.cookie.get('hjuser_session_id')) {
			Helper.cookie.set('hjuser_session_id', `web-${Helper.createUniqueID()}`, 31);
		}
		// const userKey = Helper.cookie.get('hjuser_key');
		const sessionId = Helper.cookie.get('hjuser_session_id');
		const testGroup = Helper.cookie.get('hjuser_test_group');

		window.launchDarklyClient = LDClient.initialize(window.launch_darkly_key, {
			// key: userKey || sessionId,
			key: sessionId,
			custom: {
				SessionId: sessionId,
				TestGroup: testGroup,
				ClientPlatform: "web"
			},
		});

		window.launchDarklyClient.on('ready', () => {
			const activeFlags = window.launchDarklyClient.allFlags();

			// show test group badge
			if (activeFlags['display-test-group-badge-operational']) {
				renderTestGroupBadge();
			}

			resolve();
		});
	});
};

export default {
	init: init,
};
